import { render, staticRenderFns } from "./CreateCurrency.vue?vue&type=template&id=44fe4035"
import script from "./CreateCurrency.vue?vue&type=script&lang=js"
export * from "./CreateCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports